import Modal from "./modal";

class Search {

	private static instance: Search;

	protected inputId = "title-search-input";
	protected body = $("body");
	protected input = $("#title-search-input");
	protected navbar = $("nav.navbar");
	protected searchModal = $("#searchModal");
	protected resultContainer = $(".search-result");
	protected closeIcon = $(".search-close");
	protected running = false;
	protected runningCall = false;
	protected minLength = 2;
	protected cache_key = null;
	protected cache = [];
	protected startText;
	protected oldValue;
	protected $lastNewsReference = $(".last-news-reference");
	public popup = null;


	private constructor() {
		this.startText = this.oldValue = this.input.val();

		this.input.on({
			"keyup": () => {
				this.onChange();
			},
			"focus": () => {
				if (!$("body").hasClass("active-search")) {
					this.show();
				}
			}
		});

		this.closeIcon.on("click", () => {
			if ($("body").hasClass("search-page") && !$("body").hasClass("active-search")) {
				this.input.val("");
				this.input.focus();
			} else {
				this.hide();
			}
		});

		this.searchModal.on("hidden.bs.modal", () => {
			this.hide();
		});

		$(document).on("mouseenter", ".search-item", this.handleItemHover.bind(this));
		$(document).on("mouseleave", ".search-item", this.handleItemOut.bind(this));
		$(document).on("click", ".submit-search-form", this.confirmSearchForm.bind(this));
		$(document).on("click", ".btn-search", this.confirmSearchForm.bind(this));
		$(document).on("click", ".search-backdrop", this.hide.bind(this));
		$(document).on("submit", "#title-search form", this.checkSearchForm.bind(this));
		$(document).on("click", "#search-modal .modal-container-backdrop", this.hide.bind(this));

		$(document).keyup((e) => {
			if (e.keyCode === 27) this.hide();
		});
	}

	setResult(html: string): void {
		this.popup.setContent(html);
	}

	setLastNews(): void {
		const html = `<div class="search-result-wrapper">${ this.$lastNewsReference.html() }</div>`;
		this.popup.setContent(html);
	}

	onChange(): void {
		if (!this.popup) {
			return;
		}

		if (this.running) {
			this.runningCall = true;
			return;
		}
		this.running = true;

		if (this.input.val() == this.startText) {
			//this.setLastNews();
		} else if (this.input.val() != this.oldValue) {
			this.oldValue = this.input.val();
			if ((this.input.val() as any).length >= this.minLength) {
				this.cache_key = this.inputId + "|" + this.input.val();
				if (this.cache[this.cache_key] == null) {
					$.post("/", {
							"ajax_call": "y",
							"INPUT_ID": this.inputId,
							"q": this.input.val(),
							"l": this.minLength
						},
						(result) => {
							this.cache[this.cache_key] = result;
							this.setResult(result);
							this.running = false;
							if (this.runningCall) {
								this.runningCall = false;
								this.onChange();
							}
						}
					);
					return;
				} else {
					this.setResult(this.cache[this.cache_key]);
				}
			} else {
				//this.setLastNews();
			}
		}
		this.running = false;
	};

	show(): void {
		const _this = this;

		this.body.addClass("active-search-animate");

		setTimeout(function () {
			_this.body.removeClass("active-search-animate");
			_this.body.addClass("active-search");
		}, 950);

		// this.body.addClass('active-search');
		this.navbar.addClass("search-popover");

		/*if ('isOpen' in this.popup && this.popup.isOpen)
			return;*/

		/*this.popup = new Modal({
			id: 'search-modal',
			animateShow: 'search-show',
			animateHide: 'd-none',
			showCloseIcon: false,
			onAfterHide: (e) => {
				e.destroy();
			},
			onAfterShow: (e) => {
				this.onChange();
			},
		});

		this.popup.show();*/
	}

	public hide() {
		this.body.removeClass("active-search");
		this.navbar.removeClass("search-popover");
		this.input.val("");
		// this.popup.hide();
	}

	public static getInstance(): Search {
		if (!Search.instance) {
			Search.instance = new Search();
		}

		return Search.instance;
	}


	public checkSearchForm(e) {
		//let noResult = $(document).find('.b-search-not-found').length;
		if ((this.input.val() as any).length === 0)
			e.preventDefault();
	}

	public confirmSearchForm(e) {
		e.preventDefault();
		this.input.parents("form").submit();
	}

	protected handleItemHover(e) {
		$(".search-item").removeClass("no-bottom-border");

		const item = $(e.currentTarget);
		const prevBlock = item.prev(".search-item");
		if (prevBlock.length > 0) {
			prevBlock.addClass("no-bottom-border");
		}
	}

	protected handleItemOut(e) {
		$(".search-item").removeClass("no-bottom-border");
	}
}

export default Search;
